export const EDITLOAD_GENERALSETTINGS = "EDITLOAD_GENERALSETTINGS"
export const EDITLOAD_GENERALSETTINGS_SUCCESS = "EDITLOAD_GENERALSETTINGS_SUCCESS"
export const ADD_GENERALSETTINGS = "ADD_GENERALSETTINGS"
export const ADD_GENERALSETTINGS_SUCCESS = "ADD_GENERALSETTINGS_SUCCESS"